import React, { FC } from "react";

import { CsrdForm } from "@components/main/csrd";

const CsrdFormPage: FC = () => <CsrdForm />;

export default CsrdFormPage;
